import DataConfirmationPage from '@/features/applications/[applicationId]/data-confirmation/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation',
)({
  component: DataConfirmationPage,
})
